import * as THREE from 'three'

export default class DetailLayer
{
    constructor(scene) {

        this.scene = scene

        this.activeNode = null

        this.followElement = document.querySelector(".follow");

        this.scene.time.on('tick', () =>
        {
            this.update()
        })

        // Check Click Outside Clicks
        // window.addEventListener("click", (event) => {
        //     const modal = document.querySelector(".modal");
        //     const modalContainer = document.querySelector(".modal-container");

        //     console.log("modal - data-state: ", modalContainer.getAttribute("data-state"))
        //     if (
        //         modalContainer.getAttribute("data-state") == "open" &&
        //         (event.clientX < modal.getBoundingClientRect().left || event.clientY < modal.getBoundingClientRect().top || event.clientY > modal.getBoundingClientRect().bottom || event.clientX > modal.getBoundingClientRect().right)
        //     ) {
        //         // setTimeout(() => {
        //         //     this.hidePopup();
        //         // }, 100);
        //     }
        // })
    }

    showPopup(node) {
        this.activeNode = node
        document.getElementById('node_name').innerHTML = node.data.name
        if (node.data.logo_to_attach) {
            document.getElementById('modal_logo').src = node.data.logo_to_attach
            document.getElementById('modal_logo').style.display = "block";
        } else {
            document.getElementById('modal_logo').style.display = "none";
        }
        

        // Set Colors from Database
        document.querySelector(".modal-container").style.setProperty("--primaryColor", node.data.base_color)
        document.querySelector(".modal-container").style.setProperty("--secondaryColor", node.data.secondary_color)

        document.querySelector(".modal-footer").href = node.data.link_to_dataset;
        
        let listTemplate = `
            <tr>
                <th class="c-primary t-inter">Name</th>
                <th class="c-primary t-inter">Value</th>
            </tr>
        `;
        if (node.data.table && node.data.table.length) {
            for (const entry of node.data.table) {
                listTemplate += `
                    <tr>
                        <td>${entry.key}</td>
                        <td class="t-uppercase">${entry.value}</td>
                    </tr>
                `
            }
            document.querySelector(".modal-info").innerHTML = listTemplate;
        } else {
            listTemplate = `
                <span>No data available</span>
            `;
            document.querySelector(".modal-info").innerHTML = listTemplate;
        }

        this.toggleModal()
    }

    toggleModal(close) {
        const modal = document.getElementById('modal');
        const table = modal.querySelector(".modal-info");
        const footer = modal.querySelector(".modal-footer");
        const horizontalLine = document.querySelector(".modal-line-horizontal");
        const verticalLine = document.querySelector(".modal-line-vertical");
        const infobox = document.querySelector(".infobox-container");
        const button = document.querySelector(".infobox-button");  

        //console.log("ToggleModal!")
        
        if (modal.getAttribute("data-state") == "closed" && !close) {
            modal.classList.add("visible");
            modal.setAttribute("data-state", "open")
            horizontalLine.classList.add("visible")
            verticalLine.classList.add("visible")

            // Set OpenHeight Value for Grow Animation (48px for padding value)
            setTimeout(() => {
                table.style.setProperty("--openHeight", table.scrollHeight + 48 + "px")  
                footer.style.setProperty("--openHeight", footer.scrollHeight + 48 + "px")
            }, 200);

            window.addEventListener("resize", () => {
                table.style.setProperty("--openHeight", table.scrollHeight + 48 + "px")  
                footer.style.setProperty("--openHeight", footer.scrollHeight + 48 + "px")  
            })

            // Close InfoBox
            if(infobox.getAttribute("data-state") == "open") {
                infobox.classList.add("hide");
                button.querySelector("span").innerHTML = "Exploring Data";
                infobox.setAttribute("data-state", "closed");
                clearTimeout(infoboxTimeout)

                setTimeout(() => {
                    infobox.classList.remove("visible");
                    button.classList.remove("open");
                    infobox.classList.remove("hide");
                }, 150);
            }

        } else {
            modal.classList.add("hidden");
            setTimeout(() => {
                modal.classList.remove("hidden");
                modal.classList.remove("visible");
                horizontalLine.classList.remove("visible")
                verticalLine.classList.remove("visible")
            }, 150);
            modal.setAttribute("data-state", "closed")
        }
    }

    calculateJoinLine(id, targetX, targetY) {
        const modal = document.getElementById('modal');
        const modalBullet = modal.querySelector(".modal-header-bullet");
    
        const horizontal = document.querySelector(".modal-line-horizontal")
        const vertical = document.querySelector(".modal-line-vertical")

        const modalBulletTop = modalBullet.getBoundingClientRect().top + modalBullet.getBoundingClientRect().height / 2;
        const modalBulletLeft = modalBullet.getBoundingClientRect().left + modalBullet.getBoundingClientRect().width / 2;

        const lineHeight = targetY > modalBulletTop ? targetY - modalBulletTop : modalBulletTop - targetY;
        const lineWidth = targetX > modalBulletLeft ? targetX - modalBulletLeft : modalBulletLeft - targetX;

        const rotateDegVer = targetY > modalBulletTop ? -90 : 90;
        const rotateDegHor = targetX > modalBulletLeft ? 180 : 0;

        // Vertical
        vertical.style.setProperty("--targetX", targetX + "px");
        vertical.style.setProperty("--targetY", targetY + "px");
        vertical.style.setProperty("--lineHeight", lineHeight + "px");
        vertical.style.setProperty("--rotateDegVer", rotateDegVer + "deg");
        
        
        // Horizontal
        horizontal.style.setProperty("--targetX", targetX + "px");
        horizontal.style.setProperty("--modalY", modalBulletTop + "px");
        horizontal.style.setProperty("--lineWidth", lineWidth + "px");
        horizontal.style.setProperty("--rotateDegHor", rotateDegHor + "deg");
    }   

    hidePopup(node) {
        this.activeNode = null
        //this.sprite.visible = false
        this.toggleModal()
    }

    update() {
        if (this.activeNode) {
            let screenPosition = new THREE.Vector3(0,0,0)
            this.activeNode.threeObject.getWorldPosition(screenPosition)
            screenPosition.project(this.scene.camera)
            // if (screenPosition.x > 0.6) this.material.map = this.textureF
            // else if (screenPosition.x < -0.6) this.material.map = this.texture
            // else if (screenPosition.x < 0.01) this.material.map = this.textureF
            // else if (screenPosition.x >= 0.01) this.material.map = this.texture 
            const translateX = this.scene.sizes.width * 0.5 + screenPosition.x * this.scene.sizes.width * 0.5
            const translateY = this.scene.sizes.height * 0.5 - screenPosition.y * this.scene.sizes.height * 0.5

            // this.followElement.style.setProperty("--posX", translateX + "px");
            // this.followElement.style.setProperty("--posY", translateY + "px");

            if (!this.activeNode.data.primary_blockchain) this.calculateJoinLine('modal', translateX, translateY - 18)
            else this.calculateJoinLine('modal', translateX, translateY - 10)
        }
    }
}